'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = require('../../lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'small': 'Button__small___2QO7m',
  'medium': 'Button__medium___1tG9s',
  'large': 'Button__large___3Yc6J',
  'button': 'Button__button___1QI-C',
  'isDangerousAction': 'Button__isDangerousAction___aw3xt'
};

var TextCtaButton = (0, _mergeThemeHoc2.default)(style)(_Button2.default);
TextCtaButton.displayName = 'TextCtaButton';
exports.default = TextCtaButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/dist/Button/TextCta.js
// module id = ./node_modules/dibs-elements/dist/Button/TextCta.js
// module chunks = 4